module.exports = __webpack_public_path__ + "static/media/Colette Wing Single Headboard - 120 cm_Teal.0ff1591d.png";